import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=4fb73d44&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=4fb73d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb73d44",
  null
  
)

export default component.exports